import { autoinject, inject, NewInstance } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { ValidationController, ValidationRules, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import { Location } from "../../../models/location";
import { MaterializeFormValidationRenderer } from "aurelia-materialize-bridge";
import { I18N } from "aurelia-i18n";
import { addLocation } from "../../../store/actions/location-actions";
import { dispatchify } from 'aurelia-store';

@autoinject
export class AddLocationDialog {
	dialogController: DialogController;
	validationController: ValidationController;
	i18n: I18N;

	location: Location = new Location();
	loading: boolean = false;
	message: string;

	name: string;
	code: string;
	description: string;
	rules = ValidationRules
		.ensure("name")
		.required()
		.ensure("code")
		.required()
		.ensure("description")
		.required()
		.rules;

	constructor(dialogController: DialogController, controllerFactory: ValidationControllerFactory, i18n: I18N) {
		this.dialogController = dialogController;
		this.i18n = i18n;

		this.validationController = controllerFactory.createForCurrentScope();
		this.validationController.addRenderer(new MaterializeFormValidationRenderer());
		this.validationController.validateTrigger = validateTrigger.changeOrBlur;
		this.validationController.addObject(this.location, this.rules);

		this.message = i18n.tr("adding-location");

	}

	

  bind(bindingContext: any, overrideContext: any) {
   
  }

  attached() {
    
  }

  detached() {
   
	}


    validateData() {
	    this.validationController.validate().then( v => {
			if (v.valid) {
				this.location.timeZone = "Pacific Standard Time";
				this.loading = true;
				dispatchify(addLocation)(this.location);
				this.loading = false;
			    this.dialogController.ok();
		    }
	    });
	}



}